<div class="main">
  <header class="inquiry-banner">
    <h1>
      <img
        class="center-banner-icon"
        src="assets/inquiry-center-icon.svg"
        alt=""
        aria-hidden="true"
      />
      {{ "inquiryCenter" | translate }}
    </h1>
    <p>{{ "inquiryCenterDescription" | translate }}</p>
  </header>
  <section class="inquiry-panel" [attr.aria-label]="'inquiryCenter' | translate">
    <div class="inquiry-toolbar">
      <button type="button" class="create-inquiry-button" (click)="openCreateInquiry()">
        + {{ "createInquiry" | translate }}
      </button>
    </div>
    <h2 class="filter-heading">{{ "filters" | translate }}</h2>
    <div class="search-area">
      <div class="search-bar">
        <div style="margin-bottom: 5px;">{{ "csNo" | translate }}</div>
        <div class="cs-number-search">
          <span class="cs-number-prefix">CS</span>
          <input
            [attr.aria-label]="'csNo' | translate"
            pInputText
            type="text"
            id="cs-number-search"
            [(ngModel)]="searchCsNumber"
            placeholder="YYMMDD-X"
          />
        </div>
      </div>
      <div class="search-bar">
        <div style="margin-bottom: 5px;">{{ "shipyard" | translate }}</div>
        <input
          [attr.aria-label]="'shipyard' | translate"
          pInputText
          type="text"
          id="shipyard-search"
          [(ngModel)]="searchShipyard"
          [placeholder]="'shipyard' | translate"
        />
      </div>
      <div class="search-bar">
        <div style="margin-bottom: 5px;">{{ "vesselNumber" | translate }}</div>
        <input
          [attr.aria-label]="'vesselNumber' | translate"
          pInputText
          type="text"
          id="vessel-number-search"
          [(ngModel)]="searchVesselNo"
          [placeholder]="'vesselNumber' | translate"
        />
      </div>
      <div class="search-bar">
        <div style="margin-bottom: 5px;">{{ "vesselName" | translate }}</div>
        <input
          [attr.aria-label]="'vesselName' | translate"
          pInputText
          type="text"
          id="vessel-name-search"
          [(ngModel)]="searchVesselName"
          [placeholder]="'vesselName' | translate"
        />
      </div>
      <div class="search-bar">
        <div style="margin-bottom: 5px;">{{ "inquiryTitle" | translate }}</div>
        <input
          [attr.aria-label]="'inquiryTitle' | translate"
          pInputText
          type="text"
          id="claim-title-search"
          [(ngModel)]="searchTitle"
          [placeholder]="'inquiryTitle' | translate"
        />
      </div>
      <div class="search-bar">
        <div style="margin-bottom: 5px;">{{ "incidentDateRange" | translate }}</div>
        <div class="date-picker-wrapper">
          <p-calendar
            id="claimDate"
            [(ngModel)]="incidentDateRange"
            [showIcon]="true"
            selectionMode="range"
            dateFormat="yy-mm-dd"
            placeholder="From - To"
            inputId="claimDate"
            iconDisplay="input"
            [showButtonBar]="true"
          >
          </p-calendar>
          <i
            *ngIf="incidentDateRange?.length"
            class="pi pi-times clear-btn"
            (click)="incidentDateRange = null">
          </i>
        </div>
      </div>
    </div>
    <details class="additional-filters">
      <summary>{{ "markAndTagFilters" | translate }}</summary>
      <div class="search-area additional-search-area">
      <div class="search-bar">
        <div class="search-label">
          {{ "mark" | translate }}
        </div>

        <p-dropdown
          class="search-dropdown"
          [options]="markSearchOptions"
          [(ngModel)]="searchMark"
          optionLabel="name"
          optionValue="id"
          [showClear]="true"
          [placeholder]="'mark' | translate"
          [style]="{ width: '100%' }"
        >
          <ng-template pTemplate="selectedItem" let-option>
            {{ option?.name | translate }}
          </ng-template>

          <ng-template pTemplate="item" let-option>
            {{ option.name | translate }}
          </ng-template>
        </p-dropdown>
      </div>
      <div class="search-bar tags-search-bar">
        <div class="search-label">
          {{ "tags" | translate }}
        </div>

        <div class="tag-filter-row">
          <p-chips
            class="search-tags"
            [(ngModel)]="searchTags"
            [allowDuplicate]="false"
            [caseSensitiveDuplication]="false"
            [addOnBlur]="true"
            separator=","
            [placeholder]="'tags' | translate"
          ></p-chips>

          <p-dropdown
            class="tag-match-dropdown"
            [options]="tagMatchOptions"
            [(ngModel)]="searchTagMatchMode"
            optionLabel="translationKey"
            optionValue="value"
          >
            <ng-template pTemplate="selectedItem" let-option>
              {{ option?.translationKey | translate }}
            </ng-template>

            <ng-template pTemplate="item" let-option>
              {{ option.translationKey | translate }}
            </ng-template>
          </p-dropdown>
        </div>
      </div>
      </div>
    </details>
    <div class="claim-actions">
      <div class="filter-controls">
        <details
          class="advanced-filters"
          #advancedFilters
          (keydown.escape)="advancedFilters.open = false"
          (document:click)="closeFiltersOnOutsideClick($event, advancedFilters)"
        >
          <summary>
            <span class="pi pi-sliders-v" aria-hidden="true"></span>
            {{ "statusPriorityConfidential" | translate }}
            <span *ngIf="selectedFilterCount > 0">
              ({{ selectedFilterCount }})
            </span>
          </summary>

          <div class="advanced-filter-panel">
            <fieldset>
              <legend>{{ "status" | translate }}</legend>

              <label *ngFor="let status of ['new', 'open', 'resolved', 'closed']">
                <p-checkbox
                  [value]="status"
                  [(ngModel)]="searchStatuses"
                  [inputId]="'inquiry-status-' + status"
                ></p-checkbox>
                <span>{{ status | translate }}</span>
              </label>
            </fieldset>

            <fieldset>
              <legend>{{ "priority" | translate }}</legend>

              <label>
                <p-checkbox
                  [value]="1"
                  [(ngModel)]="searchPriorities"
                  inputId="inquiry-priority-high"
                ></p-checkbox>
                <span>{{ "high" | translate }}</span>
              </label>

              <label>
                <p-checkbox
                  [value]="2"
                  [(ngModel)]="searchPriorities"
                  inputId="inquiry-priority-medium"
                ></p-checkbox>
                <span>{{ "medium" | translate }}</span>
              </label>

              <label>
                <p-checkbox
                  [value]="3"
                  [(ngModel)]="searchPriorities"
                  inputId="inquiry-priority-low"
                ></p-checkbox>
                <span>{{ "low" | translate }}</span>
              </label>
            </fieldset>

            <fieldset>
              <legend>{{ "confidential" | translate }}</legend>

              <label>
                <p-checkbox
                  [value]="true"
                  [(ngModel)]="searchConfidential"
                  inputId="inquiry-confidential-yes"
                ></p-checkbox>
                <span>{{ "yes" | translate }}</span>
              </label>

              <label>
                <p-checkbox
                  [value]="false"
                  [(ngModel)]="searchConfidential"
                  inputId="inquiry-confidential-no"
                ></p-checkbox>
                <span>{{ "no" | translate }}</span>
              </label>
            </fieldset>
          </div>
        </details>

        <div class="selected-filter-tags">
          <span
            class="selected-filter-tag"
            *ngFor="let tag of selectedFilterTags"
          >
            <span>
              <ng-container *ngIf="tag.type === 'confidential'">
                {{ "confidential" | translate }}:
              </ng-container>
              {{ tag.label | translate }}
            </span>

            <button
              type="button"
              (click)="removeSearchFilter(tag.type, tag.value)"
              [attr.aria-label]="
                ('clear' | translate) + ': ' +
                (tag.type === 'confidential'
                  ? ('confidential' | translate) + ': '
                  : '') +
                (tag.label | translate)
              "
            >
              <span class="pi pi-times" aria-hidden="true"></span>
            </button>
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <button
          type="button"
          class="clear-button"
          (click)="clearSearch()"
        >
          {{ "clear" | translate }}
        </button>

        <button
          type="button"
          class="search-button action-search-button"
          (click)="searchClaim(); advancedFilters.open = false"
          [disabled]="!canSearch"
        >
          {{ "applyFilters" | translate }}
        </button>
      </div>
    </div>
    <div class="claim-area">
      <div class="left-column">
        <div class="claim-list" *ngIf="!isSearching">
          <div *ngIf="hasLoadedOnce && allClaims.length === 0" class="empty-state">
            {{ "inquiriesNotFound" | translate }}
          </div>
          <div class="claim-table-header-scroll-version">
            <span class="claim-column claim-col-status">{{ "status" | translate }}</span>
            <span class="claim-column claim-col-readable-id">{{ "csNo" | translate }}</span>
            <span class="claim-column claim-col-shipyard">{{ "shipyard" | translate }}</span>
            <span class="claim-column claim-col-vessel-number">{{ "vesselNumber" | translate }}</span>
            <span class="claim-column claim-col-vessel-name">{{ "vesselName" | translate }}</span>
            <span class="claim-column claim-col-title">{{ "inquiryTitle" | translate }}</span>
            <span class="claim-column claim-col-requester">{{ "requesterName" | translate }}</span>
            <span class="claim-column claim-col-created-at">{{ "incidentDate" | translate }}</span>
          </div>
          <div class="list" (scroll)="onScroll($event)">
            <div *ngFor="let item of allClaims; trackBy: trackByClaimId" class="list-item-scroll-version" (click)="editClaim(item)">
              <span class="claim-column claim-col-status">
                <span [ngClass]="{'new-tag': getDispStatus(item) === 'new', 'open-tag': getDispStatus(item) === 'open', 'resolved-tag': getDispStatus(item) === 'resolved', 'closed-tag': getDispStatus(item) === 'closed'}">
                  {{ getDispStatus(item) | translate }}
                </span>
              </span>
              <span class="list-txt claim-column claim-col-readable-id">{{ item.csNumber }}</span>
              <span class="list-txt claim-column claim-col-shipyard">{{ getVesselBuilder(item.vesselId) }}</span>
              <span class="list-txt claim-column claim-col-vessel-number">{{ getVesselNo(item.vesselId) }}</span>
              <span class="list-txt claim-column claim-col-vessel-name">{{ getVesselName(item.vesselId) }}</span>
              <span class="list-txt claim-column claim-col-title" [ngClass]="{ 'unreadClaim': !item.isRead}">{{ item.title }}</span>
              <span class="list-txt claim-column claim-col-requester">{{ getUserName(item.submittedUserId) }}</span>
              <span class="list-txt claim-column claim-col-created-at">{{ getDate(item.incidentDate) }}</span>
            </div>
          </div>
        </div>

        <div class="claim-list" *ngIf="isSearching">
          <div class="claim-table-header">
            <span class="claim-column claim-col-status">{{ "status" | translate }}</span>
            <span class="claim-column claim-col-readable-id">{{ "csNo" | translate }}</span>
            <span class="claim-column claim-col-shipyard">{{ "shipyard" | translate }}</span>
            <span class="claim-column claim-col-vessel-number">{{ "vesselNumber" | translate }}</span>
            <span class="claim-column claim-col-vessel-name">{{ "vesselName" | translate }}</span>
            <span class="claim-column claim-col-title">{{ "inquiryTitle" | translate }}</span>
            <span class="claim-column claim-col-requester">{{ "requesterName" | translate }}</span>
            <span class="claim-column claim-col-created-at">{{ "incidentDate" | translate }}</span>
          </div>
          <div *ngIf="filteredSearchResults.length === 0" class="empty-state">
            {{ "inquiriesNotFound" | translate }}
          </div>
          <div class="search-results-list">
            <div *ngFor="let item of filteredSearchResults; trackBy: trackByClaimId" class="list-item" (click)="editClaim(item)">
              <span class="claim-column claim-col-status">
                <span [ngClass]="{'new-tag': getDispStatus(item) === 'new', 'open-tag': getDispStatus(item) === 'open', 'resolved-tag': getDispStatus(item) === 'resolved', 'closed-tag': getDispStatus(item) === 'closed'}">
                  {{ getDispStatus(item) | translate }}
                </span>
              </span>
              <span class="list-txt claim-column claim-col-readable-id">{{ item.csNumber }}</span>
              <span class="list-txt claim-column claim-col-shipyard">{{ getVesselBuilder(item.vesselId) }}</span>
              <span class="list-txt claim-column claim-col-vessel-number">{{ getVesselNo(item.vesselId) }}</span>
              <span class="list-txt claim-column claim-col-vessel-name">{{ getVesselName(item.vesselId) }}</span>
              <span class="list-txt claim-column claim-col-title" [ngClass]="{ 'unreadClaim': !item.isRead}">{{ item.title }}</span>
              <span class="list-txt claim-column claim-col-requester">{{ getUserName(item.submittedUserId) }}</span>
              <span class="list-txt claim-column claim-col-created-at">{{ getDate(item.incidentDate) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="right-column">
        <div class="chart-container">
          <div class="chart-title">
            {{ "yourInquirytatus" | translate }}
          </div>
          <div class="chart">
            <canvas 
              baseChart
              [type]="'doughnut'"
              [data]="myClaimsData"
              [options]="chartConfig"
            >
            </canvas>
            <div class="claim-summary">
              <div class="summary-txt">{{ "youHave" | translate}}</div>
              <div class="summary-no">{{ myTotalTickets }}</div>
              <div class="summary-txt">{{ "total" | translate}}</div>
              <div class="summary-txt">{{ "tickets" | translate}}</div>
            </div>
          </div>
          <div class="statistics">
            <div class="status" style="margin-bottom: 12px;">
              <div>
                <span style="background-color: #1976d2" class="dot"></span>
                <span class="status-txt">{{ "claimStatusNew" | translate }}</span>
              </div>
              <span class="value">{{ myClaimsSummary.New }}</span>
            </div>
            <div class="status" style="margin-bottom: 12px;">
              <div>
                <span style="background-color: #f57c00" class="dot"></span>
                <span class="status-txt">{{ "claimStatusOpen" | translate }}</span>
              </div>
              <span class="value">{{ myClaimsSummary.Open }}</span>
            </div>
            <div class="status" style="margin-bottom: 12px;">
              <div>
                <span style="background-color: #388e3c" class="dot"></span>
                <span class="status-txt">{{ "claimStatusResolved" | translate }}</span>
              </div>
              <span class="value">{{ myClaimsSummary.Resolved }}</span>
            </div>
            <div class="status" style="margin-bottom: 12px;">
              <div>
                <span style="background-color: #000000" class="dot"></span>
                <span class="status-txt">{{ "claimStatusClosed" | translate }}</span>
              </div>
              <span class="value">{{ myClaimsSummary.Closed }}</span>
            </div>
          </div>
        </div>
        <div class="chart-container">
          <div class="chart-title">
            {{ "overallInquiryStatus" | translate }}
          </div>
          <div class="chart">
            <canvas 
              baseChart
              [type]="'doughnut'"
              [data]="allClaimsData"
              [options]="chartConfig"
            >
            </canvas>
            <div class="claim-summary">
              <div class="summary-txt">{{ "yourTeamHas" | translate }}</div>
              <div class="summary-no">{{ teamTotalTickets }}</div>
              <div class="summary-txt">{{ "total" | translate }}</div>
              <div class="summary-txt">{{ "tickets" | translate }}</div>
            </div>
          </div>
          <div class="statistics">
            <div class="status" style="margin-bottom: 12px;">
              <div>
                <span style="background-color: #1976d2" class="dot"></span>
                <span class="status-txt">{{ "claimStatusNew" | translate }}</span>
              </div>
              <span class="value">{{ allClaimsSummary.New }}</span>
            </div>
            <div class="status" style="margin-bottom: 12px;">
              <div>
                <span style="background-color: #f57c00" class="dot"></span>
                <span class="status-txt">{{ "claimStatusOpen" | translate }}</span>
              </div>
              <span class="value">{{ allClaimsSummary.Open }}</span>
            </div>
            <div class="status" style="margin-bottom: 12px;">
              <div>
                <span style="background-color: #388e3c" class="dot"></span>
                <span class="status-txt">{{ "claimStatusResolved" | translate }}</span>
              </div>
              <span class="value">{{ allClaimsSummary.Resolved }}</span>
            </div>
            <div class="status" style="margin-bottom: 12px;">
              <div>
                <span style="background-color: #000000" class="dot"></span>
                <span class="status-txt">{{ "claimStatusClosed" | translate }}</span>
              </div>
              <span class="value">{{ allClaimsSummary.Closed }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>